import { createFileRoute, SearchSchemaInput, useNavigate } from '@tanstack/react-router'
import searchIcon from "@/assets/paytm/search.png"
import dismissIcon from "@/assets/paytm/dismiss.png"
import { useEffect, useState } from 'react'
import { DatePicker } from "@/components/ui/datepicker"
import OrderDetails from '@/components/features/paytm/order-details'
import dayjs from 'dayjs'
import { Api, searchSubStr } from '@/lib/utils'
import { useQuery } from '@tanstack/react-query'
import { Order } from '@/lib/interfaces'
import { useStore } from '@/store'
import { useShallow } from 'zustand/shallow'

export const Route = createFileRoute('/shikhar/orders/')({
    component: RouteComponent,
    validateSearch: (search: Record<string, unknown> & SearchSchemaInput): { date: string } => {
        return {
            date: search.date as string || dayjs().format('YYYY-MM-DD')
        }
    }
})

function RouteComponent() {
    const { date } = Route.useSearch()
    const [searchFilter, setSearchFilter] = useState('')
    const navigate = useNavigate()
    const { token, setPaytmtab, loggedId } = useStore(useShallow(state => ({ token: state.token, setPaytmtab: state.setPaytmTab, loggedId: state.loggedIn })))

    const getOrders = useQuery({
        queryKey: ['orders', date, token],
        queryFn: () => Api<Order[]>('/webui/orders_detailed_v2', "POST", { date }, { token }),
        staleTime: 60 * 1000,
        refetchInterval: 90 * 1000,
        refetchOnWindowFocus: false,
        enabled: loggedId
    })

    useEffect(() => {
        setPaytmtab('Orders')
    }, [])

    return <div className='absolute left-0 right-0 top-0 bottom-0'>
        <div className="h-14 flex justify-between px-4 items-center bg-light-blue w-full">
            <div className="flex items-center">
                <p className="font-semibold text-lg">My Orders</p>
            </div>
        </div>
        <div className='flex items-center justify-between m-4'>
            <DatePicker date={dayjs(date).toDate()} onChange={dateValue => {
                navigate({
                    to: '.',
                    search: { date: dayjs(dateValue).format('YYYY-MM-DD') }
                })
            }} />
        </div>
        <div className="flex items-center p-2 border border-black rounded-lg m-4 justify-between">
            <div className="flex items-center w-full">
                <img src={searchIcon} className="w-6 mr-2" />
                <input className="border-none outline-none text-sm font-medium w-full" placeholder="Search by order number or name" value={searchFilter} onChange={e => setSearchFilter(e.target.value)} />
            </div>
            <img src={dismissIcon} className={`w-6 ${!searchFilter ? 'opacity-20' : ''}`} onClick={() => setSearchFilter('')} />
        </div>
        <div className="absolute top-[170px] bottom-20 overflow-auto w-full p-4 *:mb-4">
            {[...(getOrders.data || [])].filter(e => !searchFilter || searchSubStr(searchFilter, [e.orderId, e.clientOrderId]).length > 0).map(eachOrder => {
                return <OrderDetails key={eachOrder.orderId}
                    billNumber={eachOrder.clientOrderId}
                    orderAmount={eachOrder.priceWithGST.toFixed(2)}
                    createdAt={dayjs(eachOrder.createdAt).format('D MMM, hh:mm A')}
                    status={eachOrder.orderState}
                    pickupAddr={eachOrder.pickupAddress.name + ', ' + eachOrder.pickupAddress.line1 + ', ' + eachOrder.pickupAddress.line2}
                    dropAddr={eachOrder.dropAddress.name + ', ' + eachOrder.dropAddress.line1 + ', ' + eachOrder.dropAddress.line2}
                    pickupOtp={eachOrder.dropOtp || '- -'}
                    dropOtp={eachOrder.rtoOtp || '- -'}
                    pickupOtpLabel="Drop OTP"
                    dropOtpLabel="RTO OTP"
                    showOtp={false}
                    onClick={() => navigate({ to: '/shikhar/orders/$orderId', params: { orderId: eachOrder.orderId } })}
                />
            })}
        </div>
    </div>
}
